import {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css, Global} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flexAbsoluteCenter, flexDirection, mt, ph, position, pv, w100} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";
import {pluralize, propertyOffer} from "@pg-mono/string-utils";
import {PROPERTY_CONFIGURATOR_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../app/rp_reducer";
import {fetchAllPropertiesCountAction} from "../actions/fetch_all_properties_count_action";
import {PropertyConfiguratorStep} from "../types/PropertyConfiguratorStep";

interface ITab {
    value: PropertyConfiguratorStep;
    label: string;
}

interface IProps {
    handleTabChange: (value: PropertyConfiguratorStep, prev?: boolean) => void;
    prevTab?: ITab;
    nextTab: ITab;
    currentTab: PropertyConfiguratorStep;
}

export const ActionButtons = ({handleTabChange, prevTab, nextTab, currentTab}: IProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();
    const propertiesCount = useSelector((store: IRPStore) => store.propertyConfigurator.propertiesCount);

    const [isSticky, setIsSticky] = useState(true);
    const calcSticky = () => {
        const currentBottom = wrapperRef.current?.getBoundingClientRect().bottom as number;
        setIsSticky(currentBottom >= window.innerHeight);
    };

    const formValues = useSelector((store: IRPStore) => store.propertyConfigurator.formValues);

    useEffect(() => {
        const disablePriceFiltering = currentTab !== PropertyConfiguratorStep.BUDGET;
        dispatch(fetchAllPropertiesCountAction(disablePriceFiltering));
    }, [formValues]);

    useEffect(() => {
        window.addEventListener("scroll", calcSticky);
        return () => window.removeEventListener("scroll", calcSticky);
    }, []);

    const availabilityPlural = pluralize(["Dostępna", "Dostępne", "Dostępnych"]);

    return (
        <Wrapper isSticky={isSticky} ref={wrapperRef}>
            <Global styles={preventOverflowX} />
            <div css={buttonsContainer}>
                {!!prevTab && (
                    <Button
                        onClick={() => handleTabChange(prevTab.value, true)}
                        variant="outlined_secondary"
                        dataTestId={PROPERTY_CONFIGURATOR_TEST_IDS.PREV_BUTTON}
                    >
                        {prevTab.label}
                    </Button>
                )}
                <Button
                    disabled={!propertiesCount}
                    onClick={() => handleTabChange(nextTab.value, false)}
                    variant="filled_primary"
                    dataTestId={PROPERTY_CONFIGURATOR_TEST_IDS.NEXT_BUTTON}
                >
                    {nextTab.label}
                </Button>
            </div>
            <Text variant="body_copy_1">
                {propertiesCount ? (
                    <>
                        {availabilityPlural(propertiesCount)}&nbsp;
                        <Highlight strong>{`${propertiesCount} ${propertyOffer.nominative(propertiesCount)}`}</Highlight>
                    </>
                ) : (
                    "Brak dostępnych ofert, zmień kryteria wyszukiwania"
                )}
            </Text>
        </Wrapper>
    );
};

interface WrapperProps {
    isSticky: boolean;
}

const Wrapper = styled.div<WrapperProps>`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    ${mt(4)};
    ${w100};
    gap: ${calculateRemSize(1)};
    ${position("sticky")};
    background-color: #fff;
    ${ph(0)};
    ${pv(2)};
    bottom: 0;
    max-width: 100vw;

    button {
        max-width: initial;
        ${w100};
    }

    @media (min-width: ${({theme}) => theme.breakpoints.xs}) {
        ${ph(3)};
        button {
            max-width: 200px;
            ${w100};
        }
    }

    @media (min-width: ${({theme}) => theme.breakpoints.md}) {
        ${position("initial")};
        padding: initial;
        bottom: initial;
        z-index: initial;
        width: initial;
        box-shadow: initial;
        align-self: center;

        button {
            width: 200px;
        }
    }

    ${({isSticky}) =>
        isSticky &&
        css`
            z-index: 99;
            width: 100vw;
            align-self: center;
            ${ph(3.5)};
            box-shadow: 0 16px 60px 0 #aeb1b499;
        `};
`;

const buttonsContainer = css`
    ${flexAbsoluteCenter};
    ${flexDirection("row")};
    gap: ${calculateRemSize(1)};
    ${w100};
`;

const preventOverflowX = css`
    html {
        overflow-x: hidden;
    }
`;
import {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css, Global} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flexAbsoluteCenter, flexDirection, mt, ph, position, pv, w100} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";
import {pluralize, propertyOffer} from "@pg-mono/string-utils";
import {PROPERTY_CONFIGURATOR_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../app/rp_reducer";
import {fetchAllPropertiesCountAction} from "../actions/fetch_all_properties_count_action";
import {PropertyConfiguratorStep} from "../types/PropertyConfiguratorStep";

interface ITab {
    value: PropertyConfiguratorStep;
    label: string;
}

interface IProps {
    handleTabChange: (value: PropertyConfiguratorStep, prev?: boolean) => void;
    prevTab?: ITab;
    nextTab: ITab;
    currentTab: PropertyConfiguratorStep;
}

export const ActionButtons = ({handleTabChange, prevTab, nextTab, currentTab}: IProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();
    const propertiesCount = useSelector((store: IRPStore) => store.propertyConfigurator.propertiesCount);

    const [isSticky, setIsSticky] = useState(true);
    const calcSticky = () => {
        const currentBottom = wrapperRef.current?.getBoundingClientRect().bottom as number;
        setIsSticky(currentBottom >= window.innerHeight);
    };

    const formValues = useSelector((store: IRPStore) => store.propertyConfigurator.formValues);

    useEffect(() => {
        const disablePriceFiltering = currentTab !== PropertyConfiguratorStep.BUDGET;
        dispatch(fetchAllPropertiesCountAction(disablePriceFiltering));
    }, [formValues]);

    useEffect(() => {
        window.addEventListener("scroll", calcSticky);
        return () => window.removeEventListener("scroll", calcSticky);
    }, []);

    const availabilityPlural = pluralize(["Dostępna", "Dostępne", "Dostępnych"]);

    return (
        <Wrapper isSticky={isSticky} ref={wrapperRef}>
            <Global styles={preventOverflowX} />
            <div css={buttonsContainer}>
                {!!prevTab && (
                    <Button
                        onClick={() => handleTabChange(prevTab.value, true)}
                        variant="outlined_secondary"
                        dataTestId={PROPERTY_CONFIGURATOR_TEST_IDS.PREV_BUTTON}
                    >
                        {prevTab.label}
                    </Button>
                )}
                <Button
                    disabled={!propertiesCount}
                    onClick={() => handleTabChange(nextTab.value, false)}
                    variant="filled_primary"
                    dataTestId={PROPERTY_CONFIGURATOR_TEST_IDS.NEXT_BUTTON}
                >
                    {nextTab.label}
                </Button>
            </div>
            <Text variant="body_copy_1">
                {propertiesCount ? (
                    <>
                        {availabilityPlural(propertiesCount)}&nbsp;
                        <Highlight strong>{`${propertiesCount} ${propertyOffer.nominative(propertiesCount)}`}</Highlight>
                    </>
                ) : (
                    "Brak dostępnych ofert, zmień kryteria wyszukiwania"
                )}
            </Text>
        </Wrapper>
    );
};

interface WrapperProps {
    isSticky: boolean;
}

const Wrapper = styled.div<WrapperProps>`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    ${mt(4)};
    ${w100};
    gap: ${calculateRemSize(1)};
    ${position("sticky")};
    background-color: #fff;
    ${ph(0)};
    ${pv(2)};
    bottom: 0;
    max-width: 100vw;

    button {
        max-width: initial;
        ${w100};
    }

    @media (min-width: ${({theme}) => theme.breakpoints.xs}) {
        ${ph(3)};
        button {
            max-width: 200px;
            ${w100};
        }
    }

    @media (min-width: ${({theme}) => theme.breakpoints.md}) {
        ${position("initial")};
        padding: initial;
        bottom: initial;
        z-index: initial;
        width: initial;
        box-shadow: initial;
        align-self: center;

        button {
            width: 200px;
        }
    }

    ${({isSticky}) =>
        isSticky &&
        css`
            z-index: 99;
            width: 100vw;
            align-self: center;
            ${ph(3.5)};
            box-shadow: 0 16px 60px 0 #aeb1b499;
        `};
`;

const buttonsContainer = css`
    ${flexAbsoluteCenter};
    ${flexDirection("row")};
    gap: ${calculateRemSize(1)};
    ${w100};
`;

const preventOverflowX = css`
    html {
        overflow-x: hidden;
    }
`;
